<template>
  <div class="quotes-list-sorts-fields">
    <el-radio-group v-model="value.sort">
      <el-radio label="pickup.earliestDate">{{
        $t('QUOTES_LIST_SORTS_FIELDS.PICKUP.EARLIEST_DATE.TITLE') }}
      </el-radio>
      <el-radio label="delivery.earliestDate">{{
        $t('QUOTES_LIST_SORTS_FIELDS.DELIVERY.EARLIEST_DATE.TITLE') }}
      </el-radio>
      <el-radio label="deadLine">{{ $t('QUOTES_LIST_SORTS_FIELDS.DEADLINE.TITLE') }}
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'QuotesListSortsFields',
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.quotes-list-sorts-fields {
  .el-radio {
    display: block;
    line-height: 40px;
  }
}
</style>
